import { Module } from 'vuex';
import { AdpDocument, Article, Comment } from '@/types';

export type ArticleShareState = {
  article?: AdpDocument;
  comment?: Comment;
  isSharing: boolean;
};

export const initialArticleShareState: ArticleShareState = {
  article: undefined,
  comment: undefined,
  isSharing: false,
};

const articleShare: Module<ArticleShareState, unknown> = {
  namespaced: true,
  state: {
    ...initialArticleShareState,
  },
  mutations: {
    setArticle(state: ArticleShareState, article: Article): void {
      state.article = article;
    },
    setComment(state: ArticleShareState, comment: Comment): void {
      state.comment = comment;
    },
    setIsSharing(state: ArticleShareState, isSharing: boolean) {
      state.isSharing = isSharing;
    },
  },
};

export default articleShare;
